/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_BASE_LOG_URL, COMMON_HEADER_CONFIG} from "../config";

class LogService {
  getAccessToken = () => localStorage.getItem("accessToken");

  getListLog = (params = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_BASE_LOG_URL}/logs`,
        params: {
          page: 1,
          ...params
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getDetailLog = (logId) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_BASE_LOG_URL}/log/${logId}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data) {
            resolve(response.data.data);
          } else {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const logService = new LogService();

export default logService;
